import { useCallback } from 'react';
import { ApiError, DomainError } from '../../gql/graphql-fetcher';
import { useNotification } from '../../utils/useNotification';
import { useIntl } from 'react-intl';

export const useErrorHandler = () => {
  const { notifyFailure } = useNotification();
  const { formatMessage } = useIntl();
  const isDev = import.meta.env.DEV;
  const handleError = useCallback((error: unknown) => {
    if (error instanceof DomainError) {
      notifyFailure(error.message);
    } else if (error instanceof ApiError) {
      notifyFailure(isDev ? error.message : formatMessage({ id: 'An unexpected error has occurred' }));
    }
  }, [notifyFailure]);

  return { handleError };
};